import * as api from "../api";
import dayjs from "dayjs";
import { ALERT, RESET_QUOTE } from "../constants/actionTypes";

export const approvePayment = async (
  id,
  payment,
  dispatch,
  history,
  urgent,
  price,
) => {
  const userEmail = JSON.parse(localStorage.getItem("auth")).email;

  try {
    await api.updateQuote(id, {
      status: "active",
      payment,
      userEmail,
      deliveryDate: dayjs().add(5, "day").$d,
    });
    await api.issueInvoice({
      id,
      paid: price,
      price,
      email: userEmail,
    });
    if (urgent) await api.counter({ urgent_projects: 1 });
    if (!urgent) await api.counter({ unassigned_projects: 1 });
    dispatch({
      type: ALERT,
      payload: {
        severity: "success",
        message: "Payment made successfully, project activated",
        duration: 5000,
        display: true,
      },
    });
    dispatch({ type: RESET_QUOTE });
    history.replace("/projects/index");
  } catch (error) {
    if (error.response)
      dispatch({
        type: ALERT,
        payload: {
          severity: "error",
          message: error.response.data.message,
          duration: 5000,
          display: true,
        },
      });
    else
      dispatch({
        type: ALERT,
        payload: {
          severity: "error",
          message: "An unexpected error occurred",
          duration: 5000,
          display: true,
        },
      });
  }
};
